/**
 * Load vue components
 */
import $ from "jquery";
import Vue from 'vue';
import Vuex from 'vuex';
import VueGtm from '@gtm-support/vue2-gtm';
import router from "./router";
import VueObserveVisibility from 'vue-observe-visibility'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import DateRangePicker from 'vue2-daterange-picker';
import Vuelidate from 'vuelidate';
import vSelect from "vue-select";
import VueDragscroll from 'vue-dragscroll';
import vueMoment from 'vue-moment';
import * as VueGoogleMaps from "vue2-google-maps";

import Modules from './vueComponents/Modules';
import ModuleStore from './vueComponents/ModuleStore';
import WineClubStore from './vueComponents/wineclub/WineClubStore';

import ShoppingCart from './vueComponents/ecommerce/ShoppingCart';
import CartStore from './vueComponents/ecommerce/CartStore';

import ProductDetails from './vueComponents/ecommerce/ProductDetails';
import ProductStore from './vueComponents/ecommerce/ProductStore';
import OrderHistory from './vueComponents/ecommerce/OrderHistory';
import PurchaseTracker from './vueComponents/ecommerce/PurchaseTracker';

import AgeVerifier from './vueComponents/components/AgeVerifier';
import ComponentStore from './vueComponents/components/ComponentStore';
import SiteHeader from './vueComponents/components/SiteHeader';
import SiteFooter from './vueComponents/components/SiteFooter';
//import Subscription from './vueComponents/components/Subscription';

window.$ = window.jQuery = $;

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(DateRangePicker);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(VueDragscroll);
Vue.use(vueMoment);
Vue.use(VueObserveVisibility);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDk3FxaqOHSQiAFjLse87dO9WlPYxCjf08',
        libraries: 'places'
    }
});

Vue.use(VueGtm, {
    id: 'GTM-T9SFFVF', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    // queryParams: {
    //     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    //     gtm_preview: 'env-4',
    //     gtm_cookies_win: 'x'
    // },
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});

Vue.config.silent = false;

const store = new Vuex.Store({
    modules: {
        ModuleStore,
        ComponentStore,
        CartStore,
        ProductStore,
        WineClubStore
    },
});

Vue.component('v-select', vSelect)

/**
 * Render site header
 */

let header = document.querySelector('#site-header');
if (header) {
    const rootComponent = Vue.extend(SiteHeader);
    new rootComponent({
        el: header,
        propsData: {...header.dataset},
        store,
    });
}

/**
 * Render site footer
 */
let footer = document.querySelector('#site-footer');
if (footer) {
    new Vue({
        router,
        store,
        render: r => r(SiteFooter)
    }).$mount('#site-footer');
}

/**
 * Render age verifier
 */
let ageVerifier = document.querySelector('#age-verifier');
if (ageVerifier) {
    new Vue({
        router,
        store,
        render: r => r(AgeVerifier)
    }).$mount('#age-verifier');
}

/**
 * Render content modules
 */
let modules = document.querySelector('#content-modules');
if (modules) {
    new Vue({
        router,
        store,
        render: r => r(Modules)
    }).$mount('#content-modules');
}

/**
 * render product details
 */
let Product = document.querySelector('#product-details');
if (Product) {
    new Vue({
        router,
        store,
        render: r => r(ProductDetails)
    }).$mount('#product-details');
}

/**
 * Render shopping cart
 */
let cart = document.querySelector('#shopping-cart');
if (cart) {
    new Vue({
        router,
        store,
        render: r => r(ShoppingCart)
    }).$mount('#shopping-cart');
}


/**
 * Render shopping cart
 */
let orderhistory = document.querySelector('#order-history');
if (orderhistory) {
    new Vue({
        router,
        store,
        render: r => r(OrderHistory)
    }).$mount('#order-history');
}

/**
 * initialise a tacker vue component for sending data to gtm
 */
let purchase = document.querySelector('#purchase-tracker');
if (purchase) {
    const rootComponent = Vue.extend(PurchaseTracker);
    new rootComponent({
        el: purchase,
        propsData: {...purchase.dataset},
        store,
    });
}


/**
 * Load non-vue components
 */
import JSComponentLoader from './jsComponents/Loader';
import {components} from './jsComponents/Components';

const jsLoader = new JSComponentLoader(components);
document.addEventListener("DOMContentLoaded", function () {
    if (components) {
        jsLoader.load();
    }
});

import './vueComponents/components/Subscription'
import './vueComponents/components/Cta'
